exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.selected {\n    background-color: var(--primary) !important;\n    color: white;\n}\n", ""]);

// exports
